import { render, staticRenderFns } from "./EditBusinessBranchStepper.vue?vue&type=template&id=643e1c4d&"
import script from "./EditBusinessBranchStepper.vue?vue&type=script&lang=js&"
export * from "./EditBusinessBranchStepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports